import { Divider, Grid, Stack, Typography } from "@mui/material";
import { Error } from "@mui/icons-material";
import { AssetRetrievalDevice } from "../../types/assetRetrieval";

export default function SerialNumberMismatch({ assetRetrievalDevice }: { assetRetrievalDevice: AssetRetrievalDevice }) {
  return (
    <>
      <Stack gap={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Error color="revivnYellow" />
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Serial number reconciled at intake
          </Typography>
        </Stack>

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="body2">Recorded from device</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "monospace" }}>
              {assetRetrievalDevice.asset?.serialNumber}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Submitted with order</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "monospace" }}>
              {assetRetrievalDevice.serialNumber}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Typography variant="body2">Certificates and reports use the recorded serial.</Typography>
      </Stack>
    </>
  );
}
